import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled, { css } from "styled-components";
import { FlexColumn, FlexRow, FlexRowSpaceBetween, SectionTitleSeparator } from "./common.styles";
import { HeroInner, HeroTextColumn, HeroButtonColumn, HeadlinePrimary, HeadlineSecondary } from "./PatientHistoryView.styles";
import { multilineEllipsis } from "./base.styles";
export const DetailsHeroInner = styled(HeroInner) `
    align-items: center;
`;
export const DetailsHeroTextColumn = styled(HeroTextColumn) ``;
export const DetailsHeroButtonColumn = styled(HeroButtonColumn) `
    align-self: flex-start;
`;
export const DetailsHeadlinePrimary = styled(HeadlinePrimary) `
    line-height: normal;
`;
export const DetailsHeadlineSecondary = styled(HeadlineSecondary) `
    line-height: normal;
`;
export const DetailsHeroSection = styled.div `
    position: relative;
    width: 100%;
    padding: 32px 24px;
    border-bottom: 0.37px solid ${colors.history_separator};
    box-sizing: border-box;
    overflow: hidden;
    isolation: isolate;
    background-color: ${(props) => props.$bgColor};

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        background-image: linear-gradient(41.44deg, rgba(153, 157, 162, 0.2) 0%, rgba(186, 188, 191, 0) 100%);
        pointer-events: none;
        z-index: 0;
    }

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background-image: radial-gradient(ellipse 70% 140% at 12% 40%, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0) 100%);
        pointer-events: none;
        z-index: 0;
    }

    @media print {
        &::before,
        &::after {
            display: none;
        }
    }
`;
export const DetailsPageRoot = styled.div `
    display: flex;
    flex-direction: column;
    background-color: ${colors.history_surface_bg};
    flex: 1 0 auto;
    min-height: 100%;
    width: 100%;
`;
export const DetailsSectionTitle = styled(SectionTitleSeparator) `
    padding: 24px 0;
    ${(props) => props.$paddingBottom &&
    css `
            padding-bottom: ${props.$paddingBottom};
        `}
`;
export const ProviderSectionContainer = styled(FlexColumn) `
    padding: 0 16px;
`;
export const ProviderRow = styled.div `
    display: flex;
    gap: 16px;
    align-items: flex-start;
    padding: 16px 0 0 0;
    align-self: stretch;
`;
export const ProviderIconCircle = styled.div `
    width: 44px;
    height: 32px;
    border-radius: 24px;
    background-color: ${colors.provider_icon_bg};
    border: 0.5px solid ${colors.history_separator};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;
export const ProviderTextBlock = styled(FlexColumn) `
    flex: 1;
    min-width: 0;
    gap: 4px;
    padding-bottom: ${(props) => (props.$showBorder ? "24px" : "16px")};
    border-bottom: ${(props) => (props.$showBorder ? `0.37px solid ${colors.history_separator}` : "none")};
`;
export const ProviderLabel = styled.p `
    margin: 0;
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_lighter};
    text-transform: uppercase;
    letter-spacing: 0.24px;
    line-height: normal;
`;
export const ProviderValue = styled.p `
    margin: 0;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_main};
    line-height: 21px;
    letter-spacing: -0.31px;
`;
export const ProviderSubtext = styled.p `
    margin: 0;
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_lighter};
    line-height: 20px;
    letter-spacing: -0.08px;
`;
export const MeasurementsContainer = styled(FlexColumn) `
    gap: 8px;
    padding: 0 16px 16px;
`;
export const MeasurementCard = styled.button `
    display: flex;
    align-items: ${(props) => { var _a; return (_a = props.$alignItems) !== null && _a !== void 0 ? _a : "center"; }};
    gap: 8px;
    padding: 20px 16px 24px;
    background: ${colors.white_main};
    border: 0.37px solid ${colors.history_separator};
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    text-align: left;

    &:disabled {
        cursor: default;
    }

    @media (hover: hover) {
        &:hover:not(:disabled) {
            background-color: ${colors.black_4};
        }
    }
`;
export const MeasurementStatusDot = styled.div `
    width: 12px;
    height: 21px;
    display: flex;
    align-items: center;
    flex-shrink: 0;

    &::after {
        content: "";
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: ${(props) => props.$color};
    }
`;
export const MeasurementContent = styled.div `
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: ${(props) => { var _a; return (_a = props.$gap) !== null && _a !== void 0 ? _a : 8; }}px;
    min-width: 0;
`;
export const MeasurementRow = styled(FlexRow) `
    align-items: center;
    gap: 16px;
`;
export const MeasurementName = styled.div `
    flex: 1;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_main};
    line-height: 21px;
    letter-spacing: -0.31px;
    min-width: 0;
`;
export const MeasurementValue = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.history_secondary_text};
    line-height: 21px;
    letter-spacing: -0.31px;
    min-width: 0;
    max-width: calc(50% - 8px);
    margin-left: auto;
    text-align: right;
`;
export const MeasurementValueSubtext = styled.div `
    font-size: ${fontSizes.TINY};
    color: ${colors.history_secondary_text};
    line-height: 18px;
`;
export const DocumentsContainer = styled(FlexColumn) `
    gap: 8px;
    padding: 0 16px 16px;
`;
export const DocumentCard = styled.button `
    display: flex;
    align-items: center;
    height: 64px;
    padding: 8px 12px 8px 8px;
    background: ${colors.white_main};
    border: 0.5px solid ${colors.history_separator_90};
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    text-align: left;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.7;
    }

    @media (hover: hover) {
        &:hover:not(:disabled) {
            background-color: ${colors.black_4};
        }
    }
`;
export const DocumentIconContainer = styled.div `
    width: 40px;
    height: 48px;
    border-radius: 2px;
    background-color: ${(props) => { var _a; return (_a = props.$bgColor) !== null && _a !== void 0 ? _a : "rgba(121, 126, 133, 0.2)"; }};
    border: 0.5px solid ${colors.history_separator};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;
export const DocumentTextBlock = styled.div `
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    padding-left: 8px;
    justify-content: center;
`;
export const DocumentName = styled.p `
    margin: 0;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_main};
    line-height: 21px;
    letter-spacing: -0.31px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
export const DocumentMeta = styled.div `
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: ${fontSizes.TINY};
    color: ${colors.history_secondary_text};
    line-height: 18px;
    white-space: nowrap;
`;
export const DocumentMetaBold = styled.span `
    font-weight: ${fontWeights.BOLD};
`;
export const DocumentMetaRegular = styled.span `
    font-weight: ${fontWeights.NORMAL};
`;
export const DocumentChevron = styled.div `
    display: flex;
    align-items: center;
    align-self: stretch;
    flex-shrink: 0;
    color: ${colors.black_lighter};
`;
export const ProvenanceContainer = styled(FlexColumn) `
    padding: 0 16px 16px;
`;
export const ProvenanceTable = styled(FlexColumn) `
    background-color: ${colors.history_separator_20};
    border: 0.37px solid ${colors.history_separator};
    border-radius: 24px;
    padding: 4px 16px;
`;
export const ProvenanceRow = styled(FlexRowSpaceBetween) `
    align-items: center;
    padding: 12px 0;
    border-bottom: ${(props) => (props.$showBorder ? `0.37px solid ${colors.history_separator}` : "none")};
    white-space: nowrap;
    font-size: ${fontSizes.LITTLE};
    letter-spacing: -0.08px;
    line-height: 20px;
    gap: 16px;
`;
export const ProvenanceLabel = styled.span `
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.history_secondary_text};
`;
export const ProvenanceValue = styled.span `
    ${multilineEllipsis(3)};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_main};
    text-align: right;
`;
export const HeroDateRow = styled.div `
    display: flex;
    align-items: baseline;
    gap: 4px;
    font-size: ${fontSizes.TINY};
    line-height: 18px;
    width: 100%;
    white-space: nowrap;
    padding: 16px 0 0 68px;
`;
export const HeroDateBold = styled.span `
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_main};
`;
export const HeroDateLight = styled.span `
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_lighter};
`;
export const InsightDescription = styled.p `
    margin: 0;
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_light};
    line-height: 24px;
    letter-spacing: -0.31px;
    width: 100%;
`;
export const InsightWhyItMattersCard = styled(FlexColumn) `
    background-color: ${colors.insight_card_bg};
    border: 0.57px solid ${colors.insight_card_border};
    border-radius: 24px;
    padding: 16px;
    gap: 16px;
    color: ${colors.black_lighter};
`;
export const InsightWhyItMattersTitle = styled.p `
    margin: 0;
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.BOLD};
    text-transform: uppercase;
    letter-spacing: 0.24px;
    line-height: normal;
    width: 100%;
`;
export const InsightWhyItMattersText = styled.p `
    margin: 0;
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.NORMAL};
    line-height: 21.5px;
    letter-spacing: -0.15px;
    width: 100%;
`;
export const InsightReferenceRow = styled.div `
    display: flex;
    gap: 8px;
    align-items: flex-start;
    align-self: stretch;
    padding: 6px 0;
    position: relative;
    z-index: 1;

    /* Negative offsets must match BottomSheetInner horizontal padding (24px) */
    ${(props) => props.$isCurrent &&
    css `
            &::before {
                content: "";
                position: absolute;
                left: -24px;
                right: -24px;
                top: 0;
                bottom: 0;
                background-color: ${colors.black_4};
                z-index: -1;
            }
        `}
`;
export const InsightRangeValueContainer = styled.div `
    display: flex;
    flex: 1 0 0;
    gap: 8px;
    align-items: center;
    min-width: 0;
`;
export const InsightRangeDot = styled.span `
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${(props) => props.$color};
    flex-shrink: 0;
`;
export const InsightRangeValue = styled.span `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_main};
    line-height: 21px;
    letter-spacing: -0.31px;
    word-break: break-word;
    ${multilineEllipsis(1)};
`;
export const InsightRangeLabelContainer = styled.div `
    display: flex;
    flex: 1 0 0;
    min-width: 0;
`;
export const InsightRangeLabel = styled.span `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_main};
    line-height: 24px;
    letter-spacing: -0.31px;
    min-width: 0;
    word-break: break-word;
    ${multilineEllipsis(1)};
`;
export const VaccinationInsightContainer = styled(FlexColumn) `
    gap: 8px;
    padding: 0 16px 16px;
`;
export const VaccinationInsightCard = styled.button `
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    background: ${colors.white_main};
    border: 0.37px solid ${colors.history_separator};
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    text-align: left;

    @media (hover: hover) {
        &:hover {
            background-color: ${colors.black_4};
        }
    }
`;
export const VaccinationInsightCardText = styled(FlexColumn) `
    flex: 1;
    gap: 2px;
    min-width: 0;
`;
export const VaccinationInsightCardTitle = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_main};
    line-height: 21px;
    letter-spacing: -0.31px;
`;
export const VaccinationInsightCardSubtitle = styled.div `
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.history_secondary_text};
    line-height: 20px;
    letter-spacing: -0.08px;
`;
export const VaccinationSideEffectsTitle = styled.p `
    margin: 0;
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.BOLD};
    text-transform: uppercase;
    letter-spacing: 0.24px;
    line-height: normal;
    color: ${colors.black_lighter};
    width: 100%;
`;
export const VaccinationSideEffectsList = styled.ul `
    margin: 0;
    padding: 0 0 0 20px;
    display: flex;
    flex-direction: column;
    gap: 6px;
`;
export const VaccinationSideEffectItem = styled.li `
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_light};
    line-height: 21.5px;
    letter-spacing: -0.15px;
`;
const PRINT_DIALOG_ONLY_CSS = `@media print {
  #root { display: none !important; }
  .MuiBackdrop-root { display: none !important; }
  .MuiDialog-root { position: static !important; overflow: visible !important; }
  .MuiDialog-container { height: auto !important; overflow: visible !important; }
  .MuiDialog-paper { max-height: none !important; height: auto !important; overflow: visible !important; box-shadow: none !important; border-radius: 0 !important; }
  .MuiDialog-paper > * { overflow: visible !important; }
}`;
export function applyPrintDialogOnlyStyles() {
    const styleEl = document.createElement("style");
    styleEl.setAttribute("data-print-dialog-only", "");
    styleEl.textContent = PRINT_DIALOG_ONLY_CSS;
    document.head.appendChild(styleEl);
    let cleaned = false;
    return () => {
        if (cleaned)
            return;
        cleaned = true;
        styleEl.remove();
    };
}
